export default "__VITE_ASSET__6h_wIV7x__"